<template>
  <div class="no_page">
    <img :src="pic" alt="no data" class="no-pic" />
    <br />
    <span class="no-tip">{{ $t("house.picTip") }}</span>

    <form id="uploadImg">
      <div class="form-box margin-bottom-20">
        <Button type="primary" size="large" class="upload-btn file"
          >{{ $t("house.upload") }}
          <input
            type="file"
            name="facePic"
            accept=".jpg,.jpeg"
            @change="showPic($event)"
            multiple
        /></Button>
      </div>
    </form>

    <form id="uploadLog">
      <div class="form-box">
        <Button
          size="large"
          icon="ios-cloud-download-outline"
          type="primary"
          ghost
          class="btn-margin file"
          >{{ $t("house.input") }}
          <input
            type="file"
            name="uploadLog"
            accept="text/xml, application/xml"
            @change="writeLog($event)"
          />
        </Button>
      </div>
    </form>

    <span class="add-tip">{{ $t("house.sendTip") }}</span>
  </div>
</template>

<script>
export default {
  name: "openList",
  components: {},
  data() {
    return {
      pic: this.global.noData,
      houseList: [],
      devNameList: JSON.parse(JSON.stringify(this.global.devNameList)),
      picItem: "",
      picList: JSON.parse(JSON.stringify(this.global.iconShowList)),
      roomList: [],
    };
  },
  watch: {},
  mounted() {},
  methods: {
    showPic($event) {
      let el = $event.currentTarget;
      let fileList = el.files;
      let fileLength = fileList.length;

      // 限制上传大小
      let sizeFlag = false;
      let nameFlag = false;
      let typeFlag = false;
      let repeatFlag = false;
      // 判断名称是否重复
      let fileNameList = [];
      if (fileLength > 0) {
        for (let i in fileList) {
          if (typeof fileList[i] === "object") {
            let fileSize = fileList[i].size;
            if (fileSize > 1024 * 1024 * 10) {
              sizeFlag = true;
            }

            // 名称中文校验
            let val = fileList[i].name;
            let nameExp = /[\u4E00-\u9FA5]/g;
            if (nameExp.test(val)) {
              nameFlag = true;
            }

            // 检验格式
            let lastName = fileList[i].name.split(".").reverse()[0];
            let allowPicReg = ["jpg", "jpeg"];
            if (!allowPicReg.includes(lastName)) {
              typeFlag = true;
            }

            // 文件名重复判断
            let firstName = fileList[i].name.split(".").reverse()[1];
            if (fileNameList.includes(firstName)) {
              repeatFlag = true;
            } else {
              fileNameList.push(firstName);
            }
          }
        }
      }
      // 名称中文 报错
      if (nameFlag) {
        this.$Message.error(this.$t("house.imgName"));
        document.getElementById("uploadImg").reset();
        return;
      }
      // 图片格式 报错
      if (typeFlag) {
        this.$Message.error(this.$t("house.imgRegTip"));
        document.getElementById("uploadImg").reset();
        return;
      }
      //   文件重复
      if (repeatFlag) {
        this.$Message.error(this.$t("house.repeatNameTip"));
        document.getElementById("uploadImg").reset();
        return;
      }
      if (fileLength > 0 && sizeFlag) {
        this.$Message.error(this.$t("house.imgSize"));
        document.getElementById("uploadImg").reset();
        return;
      } else if (fileLength > 8) {
        //   限制上传总数
        this.$Message.error(this.$t("house.imgLength"));
        let addList = [];

        for (let i in fileList) {
          if (typeof fileList[i] === "object") {
            let url = this.$common.getImgUrl(fileList[i]);
            let obj = {
              file: fileList[i],
              url: url,
              fileName: fileList[i].name.substring(
                0,
                fileList[i].name.lastIndexOf(".")
              ),
            };
            addList.push(obj);
          }
        }
        this.houseList = addList.slice(0, 8);

        this.$emit("getList", this.houseList);
      } else {
        for (let i in fileList) {
          if (typeof fileList[i] === "object") {
            let url = this.$common.getImgUrl(fileList[i]);
            let obj = {
              file: fileList[i],
              url: url,
              fileName: fileList[i].name.substring(
                0,
                fileList[i].name.lastIndexOf(".")
              ),
            };
            this.houseList.push(obj);
          }
        }

        this.$emit("getList", this.houseList);
      }
    },

    // 导入功能
    writeLog($event) {
      let el = $event.currentTarget;
      let file = el.files[0];

      let url = "";
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }

      let xml = this.loadXml(url);

      if (
        typeof xml === "string" &&
        xml.indexOf('<?xml version="1.0" encoding="UCS-2 Big Endian"?>') != -1
      ) {
        // 根据导入内容赋值 户型图数据

        this.roomList = [];
        let roomNum = xml.split("<RoomLayout").length - 1;
        if (roomNum > 0) {
          for (let i = 1; i <= roomNum; i++) {
            let obj = {
              body: "RoomLayout" + i,
              id: i - 1,
              imgDiv: [],
              visible: true,
            };

            let bodyName = "<" + obj.body + ">";
            let str = xml.split(bodyName);
            let startStr = str[1].indexOf("<Name>") + 6;
            let endStr = str[1].indexOf("</Name>");
            let nameRes = str[1].substring(startStr, endStr);
            obj.name = nameRes;
            this.roomList.push(obj);
          }
        }

        // 根据导入内容赋值 设备数据
        let devList = [];
        // 灯光
        let itemList = this.formXml("<light", "light", xml, 0, 0);
        if (itemList.length > 0) {
          devList = devList.concat(itemList);
        }

        // 空调
        let airList = this.formXml(
          "<air conditioner",
          "air conditioner",
          xml,
          0,
          1
        );
        if (airList.length > 0) {
          devList = devList.concat(airList);
        }
        // 地暖
        let underList = this.formXml(
          "<underfloor heating",
          "underfloor heating",
          xml,
          0,
          2
        );
        if (underList.length > 0) {
          devList = devList.concat(underList);
        }

        // 新风
        let freshList = this.formXml("<fresh air", "fresh air", xml, 0, 3);
        if (freshList.length > 0) {
          devList = devList.concat(freshList);
        }

        // 开关插座
        let switchList = this.formXml(
          "<switch socket",
          "switch socket",
          xml,
          0,
          4
        );
        if (switchList.length > 0) {
          devList = devList.concat(switchList);
        }

        // 窗帘
        let curtainList = this.formXml("<curtain", "curtain", xml, 0, 5);
        if (curtainList.length > 0) {
          devList = devList.concat(curtainList);
        }

        // 热水器
        let waterList = this.formXml(
          "<water heater",
          "water heater",
          xml,
          0,
          6
        );
        if (waterList.length > 0) {
          devList = devList.concat(waterList);
        }

        // 背景音乐
        let bgmList = this.formXml("<BGM", "BGM", xml, 0, 7);
        if (bgmList.length > 0) {
          devList = devList.concat(bgmList);
        }

        // 自定义设备
        let custList = this.formXml("<customdevice", "customdevice", xml, 0, 8);
        if (custList.length > 0) {
          devList = devList.concat(custList);
        }
        // 热水系统
        let hotList = this.formXml(
          "<Hot water system",
          "Hot water system",
          xml,
          0,
          9
        );
        if (hotList.length > 0) {
          devList = devList.concat(hotList);
        }

        //  根据导入内容赋值 场景数据
        let sceneList = this.formXml("<scene", "scene", xml, 1, 9);
        if (sceneList.length > 0) {
          devList = devList.concat(sceneList);
        }

        //  根据导入内容赋值 温控数据
        let vineList = [];
        let vineItem = this.formVineXml("<temperature", "temperature", xml, 0);
        vineList.push(vineItem);

        let vineItem1 = this.formVineXml("<humidity", "humidity", xml, 1);
        vineList.push(vineItem1);

        let vineItem2 = this.formVineXml("<PM2.5", "PM2.5", xml, 2);
        vineList.push(vineItem2);

        let vineItem3 = this.formVineXml(
          "<HCHO concentration",
          "HCHO concentration",
          xml,
          3
        );
        vineList.push(vineItem3);

        let vineItem4 = this.formVineXml("<TVOC", "TVOC", xml, 4);
        vineList.push(vineItem4);

        let vineItem5 = this.formVineXml("<CO2", "CO2", xml, 5);
        vineList.push(vineItem5);

        //  根据导入内容赋值 独立控制场景
        let conBodyName = "<ControlModeOfScene>";
        let coStr = xml.split(conBodyName);
        let coStartStr = coStr[1].indexOf("<IndependentControl>") + 20;
        let coEndStr = coStr[1].indexOf("</IndependentControl>");
        let coNameRes = coStr[1].substring(coStartStr, coEndStr);

        let indList = {
          body: "ControlModeOfScene",
          IndependentControl: coNameRes === "True" ? 1 : 0,
        };

        // 三恒系统

        let controlItem = {};
        controlItem = this.formMainControlXml("<Three constant master", xml);
        let controlSedItem = [];
        controlSedItem = this.formControlXml(
          "<Three constant branch",
          "Three constant branch",
          xml
        );
        if (controlSedItem.length > 0) {
          controlSedItem.unshift(controlItem);
        }

        this.$emit(
          "sendReList",
          this.roomList,
          devList,
          vineList,
          indList,
          controlSedItem
        );

        this.$emit("sendReList", this.roomList, devList, vineList, indList);
      } else {
        this.$Message.error(this.$t("house.checkType"));
      }
    },
    loadXml(xmlFile) {
      let xmlDom = null;
      if (window.ActiveXObject) {
        xmlDom = new ActiveXObject("Microsoft.XMLDOM");
        xmlDom.async = "false";
        xmlDom.load(xmlFile);
      } else if (
        document.implementation &&
        document.implementation.createDocument
      ) {
        let xmlhttp = new window.XMLHttpRequest();
        xmlhttp.open("GET", xmlFile, false);
        xmlhttp.send(null);
        xmlDom = xmlhttp.responseText;
      }
      return xmlDom;
    },

    formXml(str, strTitle, xml, types, devType) {
      let lightNum = xml.split(str).length - 1;
      let itemList = [];
      if (lightNum > 0) {
        for (let i = 1; i <= lightNum; i++) {
          let itemObj = {
            body: strTitle + i,
            id: strTitle + i,
            itemNum: devType,
            type: types, // 设备 0
          };

          let lBodyName = "<" + itemObj.body + ">";
          let lStr = xml.split(lBodyName);
          let lightObj = {};
          // Name
          let lStartStr = lStr[1].indexOf("<Name>") + 6;
          let lEndStr = lStr[1].indexOf("</Name>");
          let lNameRes = lStr[1].substring(lStartStr, lEndStr);
          lightObj.name = lNameRes;

          // on
          let oStartStr = lStr[1].indexOf("<On>") + 4;
          let oEndStr = lStr[1].indexOf("</On>");
          let oNameRes = lStr[1].substring(oStartStr, oEndStr);
          lightObj.on = oNameRes === "True" ? true : false;

          // belong
          let bStartStr = lStr[1].indexOf("<Belong>") + 8;
          let bEndStr = lStr[1].indexOf("</Belong>");
          let bNameRes = lStr[1].substring(bStartStr, bEndStr);
          lightObj.belong = bNameRes;

          // belongId
          this.roomList.map((item) => {
            if (bNameRes == item.body) {
              lightObj.belongId = item.id;
            }
          });

          //  coord

          let coStartStr = lStr[1].indexOf("<coord>") + 7;
          let coEndStr = lStr[1].indexOf("</coord>");
          let coStrRes = lStr[1].substring(coStartStr, coEndStr);
          let coListRes = coStrRes.split(",");
          lightObj.coord = [Number(coListRes[0]), Number(coListRes[1])];

          //  Visible
          let vStartStr = lStr[1].indexOf("<Visible>") + 9;
          let vEndStr = lStr[1].indexOf("</Visible>");
          let vNameRes = lStr[1].substring(vStartStr, vEndStr);
          lightObj.visible = vNameRes === "True" ? true : false;

          // index
          let iStartStr = lStr[1].indexOf("<index>") + 7;
          let iEndStr = lStr[1].indexOf("</index>");
          let iNameRes = lStr[1].substring(iStartStr, iEndStr);
          lightObj.ind = Number(iNameRes);
          if (types === 1) {
            lightObj.itemNum = Number(iNameRes);
            let nameInd = Number(iNameRes) + 1;
            lightObj.body = strTitle + nameInd;
            lightObj.id = strTitle + nameInd;
          }
          itemObj = Object.assign(itemObj, lightObj);

          itemList.push(itemObj);
        }
      }

      return itemList;
    },

    formVineXml(str, strTitle, xml, ids) {
      let temp = xml.split(str);
      let tempStartStr = temp[1].indexOf("<Name>") + 6;
      let tempEndStr = temp[1].indexOf("</Name>");
      let tempRes = temp[1].substring(tempStartStr, tempEndStr);

      let tempVisStr = temp[1].indexOf("<Visible>") + 9;
      let tempVisEndStr = temp[1].indexOf("</Visible>");
      let tempVis = temp[1].substring(tempVisStr, tempVisEndStr);

      let item = {
        body: strTitle,
        config: tempRes,
        id: ids,
        name: tempRes,
        type: 2,
        visible: tempVis === "True" ? true : false,
      };
      return item;
    },
    formMainControlXml(str, xml) {
      let tempNum = xml.split(str).length - 1;
      let temp = xml.split(str);
      let item = {};
      if (tempNum > 0) {
        let tempStartStr = temp[1].indexOf("<Name>") + 6;
        let tempEndStr = temp[1].indexOf("</Name>");
        let tempRes = temp[1].substring(tempStartStr, tempEndStr);

        let oStartStr = temp[1].indexOf("<On>") + 4;
        let oEndStr = temp[1].indexOf("</On>");
        let oNameRes = temp[1].substring(oStartStr, oEndStr);

        let tempVisStr = temp[1].indexOf("<Visible>") + 9;
        let tempVisEndStr = temp[1].indexOf("</Visible>");
        let tempVis = temp[1].substring(tempVisStr, tempVisEndStr);

        item = {
          name: tempRes,
          type: 1,
          visible: tempVis === "True" ? true : false,
          on: oNameRes === "True" ? true : false,
          configList: [],
        };
        if (item.visible) {
          item.configList.push(
            this.formMainConfigXml("<Three constant temperature", xml)
          );
          item.configList.push(
            this.formMainConfigXml("<Three constant humidity", xml)
          );
          item.configList.push(
            this.formMainConfigXml("<Three constant PM2.5", xml)
          );
          item.configList.push(
            this.formMainConfigXml("<Three constant CO2", xml)
          );
          item.configList.push(
            this.formMainConfigXml("<Three constant TVOC", xml)
          );
          item.configList.push(
            this.formMainConfigXml("<Three constant HCHO", xml)
          );
        } else {
          item.configList.push(...this.global.controlList[0].configList);
        }
      }

      return item;
    },

    formMainConfigXml(str, xml) {
      let tempNum = xml.split(str).length - 1;
      let temp = xml.split(str);
      let item = {};
      if (tempNum > 0) {
        let tempStartStr = temp[1].indexOf("<Name>") + 6;
        let tempEndStr = temp[1].indexOf("</Name>");
        let tempRes = temp[1].substring(tempStartStr, tempEndStr);

        let tempVisStr = temp[1].indexOf("<Visible>") + 9;
        let tempVisEndStr = temp[1].indexOf("</Visible>");
        let tempVis = temp[1].substring(tempVisStr, tempVisEndStr);

        const targetObj = this.global.controlList[0].configList.find(
          (item) => item.name === tempRes
        );
        item = {
          name: tempRes,
          value: tempVis === "True" ? 1 : 0,
        };
        item = Object.assign(targetObj, item);
      }

      return item;
    },
    formControlXml(str, strTitle, xml) {
      let temp = xml.split(str).length - 1;
      let itemList = [];
      if (temp > 0) {
        for (let i = 1; i <= temp; i++) {
          let bodyName = "<" + strTitle + i + ">";
          let lStr = xml.split(bodyName);
          let tempStartStr = lStr[1].indexOf("<Name>") + 6;
          let tempEndStr = lStr[1].indexOf("</Name>");
          let tempRes = lStr[1].substring(tempStartStr, tempEndStr);

          let oStartStr = lStr[1].indexOf("<On>") + 4;
          let oEndStr = lStr[1].indexOf("</On>");
          let oNameRes = lStr[1].substring(oStartStr, oEndStr);

          let tempVisStr = lStr[1].indexOf("<Visible>") + 9;
          let tempVisEndStr = lStr[1].indexOf("</Visible>");
          let tempVis = lStr[1].substring(tempVisStr, tempVisEndStr);

          let itemObj = {
            type: 0,
            name: tempRes,
            visible: tempVis === "True" ? true : false,
            on: oNameRes === "True" ? true : false,
          };

          itemList.push(itemObj);
        }
      }

      return itemList;
    },
  },
};
</script>
